<template>
    <Window :id="'StationAddRelateInfo'" :title="title" :size="'m'" ref="Window">
        <related-person class="afterNew w80pct mt2x" @Update="updateRelateList" ref="AddPerson" :isMinHeight="true"></related-person>
        <button slot="btmBtn" :class="{'disable':canConfirm==0}" class="functionBtn hover-cF bgMain tra-fast" type="button" @click="confirm">保存</button>
    </Window>
</template>
<script>
import Window from "@/components/common/ui/WindowForAlert.vue"
import RelatedPerson from "@/view/maintain/light/plant/part/RelatedPerson";
import {getLanguageStr} from "@/util/language"
import {apiAddPerson} from '@/api/maintain/plant/list'
export default {
    name:'AddRelateInfo',
    components:{Window,RelatedPerson},
    data(){
        return{
            stationId:'',
            title:getLanguageStr("crm38","添加关联人"),
            watcherIds:[],
            canConfirm:0
        }
    },
    methods:{
        getLanguageStr,
        show(data){
        	this.stationId = data.stationId;
        	this.$refs.AddPerson.reset();
        	this.$refs.Window.show();
        },
        modeChange(mode){
            this.myMode=mode
        },
        hide(){
            this.$refs.Window.hide();
        },
        confirm(){
            let req={
                stationIds:[this.stationId],
                watcherIds:this.watcherIds
            }
        	apiAddPerson(req).then(res=>{
                this.hide();
                this.$emit('refreshList');
            },error=>{
                !_.isEmpty(error) && this.$notify(error)
            })
        },
        updateRelateList(userList){
        	this.watcherIds = userList;
        	this.canConfirm = userList.length;
        }
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/maintain/plant/relate/part/AddRelateInfo.vue